import { Observable } from 'rxjs';

import { IAgGridDropdownMenuOption } from 'v2/modules/shared/components/ag-grid-dropdown-menu-cell-renderer/ag-grid-dropdown-menu-cell-renderer.component';

export enum EFulfillmentOrdersGridField {
  FULFILLMENT_ORDER_KEY = 'orderKey',
  SHIPMENT_DATE = 'shipByDate',
  QTY_SHIPPED = 'qtyShipped',
  TRACKING_NUMBER = 'trackingNumber',
  FULFILLMENT_WAREHOUSE_GROUP = 'fulfillmentWarehouseGroup',
  COST = 'cost',
  STATUS = 'orderStatus',
  CHANNEL_SYNC = 'channelSync',
  FULFILLMENT_DESTINATION = 'fulfillmentChannel',
  DESTINATION_OMS_STORE = 'fulfillmentChannelStore',
  SOURCE_REFERENCE_IDENTIFIER = 'sourceReferenceIdentifier',
}

export enum EFulfillmentOrdersGridExpandableRowField {
  ORDERED_SKU = 'sku',
  PRODUCT_NAME = 'name',
  EST_ARRIVAL_DATE = 'estArrivalDate',
  WAREHOUSE_GROUP = 'warehouseGroup',
  QUANTITY = 'quantity',
  LOT = 'lot',
  UOM = 'uom',
  QTY_AVAILABLE = 'qtyAvailable',
}

export interface IFulfillmentOrdersGridColumnDefContext {
  dropdownOptions :IAgGridDropdownMenuOption[];
  ftPushUnPushToFulfilllmentChannel :boolean;
}

export interface IFulfillmentOrdersGridOptionsContext {
  saveGridState :() => void;
  updateSelectedRows :() => void;
  refetchGridData :() => void;
  fetchFulfillmentOrderItems :(fulfillmentOrderId :number) => Observable<any>;
  ftPushUnPushToFulfilllmentChannel :boolean;
}
